import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import AssessmentIcon from "@material-ui/icons/Assessment";
import useReducerOnChange from "../..//hooks/ReducerOnChange";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _BondsAssessmentListTable, _InfoTabs } from "../components";
import { _Autocomplete, _Select } from "../form";
import useTable from "../hooks/Table";

interface IRouteParam {
    ID_Anag: string;
    ID_FideAffidamento: string;
}

export const _BondsAssessmentList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const { ID_Anag, ID_FideAffidamento = "" } = useParams<IRouteParam>();
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({
        ID_FideValutazione: "",
        ID_Utente: "",
        ID_TipoValutazioneEsito: "",
        ID_FideAffidamento: ID_FideAffidamento
    });
    const { Data, Options, IsLoading } = useTable(`/api/fidevalutazione/ricerca`, FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("FideValutazioneController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Affidamento", ID_MenuMain: 24, VariabiliMenu: { ["{ID_FideAffidamento}"]: ID_FideAffidamento } });
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={AssessmentIcon} Title="Valutazione">
                    {Glob.AzioneAbilitata("FideValutazioneController", Glob.Scrittura) && (
                        <NavLink to={`/anagrafica/${ID_Anag}/FideAffidamento/${ID_FideAffidamento}/FideValutazione/0`}>
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <AddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <_InfoTabs ID_Anag={ID_Anag} ID_FideAffidamento={ID_FideAffidamento} />
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <form noValidate autoComplete="off">
                                        <Grid container spacing={4}>
                                            <Grid item xs={12} md={2}>
                                                <TextField
                                                    fullWidth
                                                    id="ID_FideValutazione"
                                                    label={Trad.Trad("ID")}
                                                    value={FormData.ID_FideValutazione}
                                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <_Autocomplete
                                                    SearchInput
                                                    TranslationsOff
                                                    Value={FormData.ID_Utente}
                                                    Name="ID_Utente"
                                                    Label="Utente"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Utenti/ListaUtenti"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <_Select
                                                    Value={FormData.ID_TipoValutazioneEsito}
                                                    Name="ID_TipoValutazioneEsito"
                                                    Label="Esito"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Options={(Data?.Tipi && Data.Tipi["TipiFideValutazioneEsito"]) || {}}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid>
                                            <Grid item md={1}>
                                                <_Button
                                                    Attivo={!IsLoading}
                                                    Testo={Trad.Trad("Cerca")}
                                                    OnClick={() => {
                                                        Options.onChangePage(0);
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </form>
                                    <_BondsAssessmentListTable ID_Anag={ID_Anag} ID_FideAffidamento={ID_FideAffidamento} Data={Data} IsLoading={IsLoading} Options={Options} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/BondsAssessmentList.tsx